import { Tag } from 'antd';
import { ReactComponent as CaseIcon } from 'shared/assets/icons/case.svg';
import { ReactComponent as SunIcon } from 'shared/assets/icons/sun.svg';
import { TFunctionArgument, CalendarType } from 'shared/declarations/i18n';
import { CalendarEventDTO } from '../../api';

import styles from './DayTypeIcon.module.scss';

type DayTypeIconProps = {
  type: CalendarEventDTO['exclusionType'];
  title: TFunctionArgument<CalendarType, string>;
};

const DayTypeIcon: React.FC<DayTypeIconProps> = ({ type, title }): React.ReactElement => {
  switch (type) {
    case 'WORKING_DAY':
      return (
        <Tag className={styles.tag} bordered color="processing">
          <CaseIcon />
          <span>{title}</span>
        </Tag>
      );
    case 'NON_WORKING_DAY':
    default:
      return (
        <Tag className={styles.tag} bordered color="orange">
          <SunIcon />
          <span>{title}</span>
        </Tag>
      );
  }
};

export { DayTypeIcon };
